export const TAB1 = "Grundriss";
export const TAB2 = "Probenbeschriftung";
export const TAB3 = "Untersuchungsergebnisse";
export const TAB4 = "Export";
export const ERROR_SAVE = "Speichern fehlgeschlagen. Bitte erneut versuchen.";